import React from "react";
import './TauriLoader2.css';

const TauriLoader2 = ({ width, height, borderwidth, color }) => {
    return (
        <div className="tauri-loader2">
            <span className="loader2" 
                style={{ 
                    '--tauri-loader2-color': color,
                     '--tauri-loader2-width': width,
                     '--tauri-loader2-height': height,
                     '--tauri-loader2-border': borderwidth
                    }}>

            </span>
        </div>
    )
}

export default TauriLoader2